import { Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import Container from '../../common/container';
import RegularButton from '../../common/RegularButton';
import PageHeader from '../../common/pageHeader';
import ContinueButton from '../../common/continueButton';
import { useStores } from '../../store/rootStore';
import ProgressBar from '../../common/progressBar';
import BottomSpacer from '../../common/bottomSpacer';
import { GenderType } from '../../store/genderStore';
import { trackOnboardingCollectedGender } from '../../utils/analytics';

export type GenderOptionType = {
  title: string;
  value: GenderType;
  image: string;
};

const CollectGender = observer(() => {
  const { genderStore, getNextPagePath } = useStores();
  const navigate = useNavigate();

  const handleContinueButtonClick = () => {
    trackOnboardingCollectedGender(genderStore.selectedGender);
    navigate(getNextPagePath('CollectGender'));
  };

  const handleClick = (selectedGender: GenderType) => {
    genderStore.setGender(selectedGender);
  };

  const genderOptions: GenderOptionType[] = [
    { title: 'Female', value: 'female', image: '🏃‍♀️' },
    {
      title: 'Male',
      value: 'male',
      image: '🏃‍♂️',
    },
    {
      title: 'Non-binary',
      value: 'nonBinary',
      image: '🏃',
    },
  ];

  return (
    <Container>
      <ProgressBar currentPage="CollectGender" />
      <PageHeader title="Choose your gender"></PageHeader>
      <Flex direction={'column'}>
        {genderOptions.map((option, idx) => (
          <RegularButton
            key={idx}
            title={option.title}
            image={option.image}
            onClick={() => handleClick(option.value)}
            isSelected={genderStore.selectedGender === option.value}
          ></RegularButton>
        ))}
      </Flex>
      <BottomSpacer />
      <ContinueButton
        isDisabled={!genderStore.selectedGender}
        onClick={handleContinueButtonClick}
      />
    </Container>
  );
});

export default CollectGender;
